import * as API from "../../api";
import * as ActionTypes from "../action-types";
import { message } from "antd";

export const get_all_privilege_request = () => (dispatch) => {
    API.getAllPrivilege()
        .then((info) => {
            const { status, msg, privileges } = info;
            if (status === 200) {
                dispatch(get_all_privilege_success(privileges));
                message.success("Successfully got all the privilege data");
            } else {
                message.warning(msg);
            }
        })
};

const get_all_privilege_success = (privileges) => {
    return {
        type: ActionTypes.PRIVILEGE_GET_ALL,
        privileges,
    };
}